<section id="hero-section">
  <div class="container">
    <div class="container__text">
      <div class="container__text__border">
        <div class="container__text__border__clipped">
          <div>
            <h1>
              {{ productSlogan }}
            </h1>
            <span>.</span>
          </div>
          <h4 [@divState]='stateName'>
            {{ activeKeyMessage }}
          </h4>
        </div>
      </div>
    </div>
    <div class="container__img">
      <img [src]="imageUrl || '../../../assets/med.jpg'" alt="" srcset="" />
    </div>
    <!-- <img class="badge" src="../../../assets/Badge.png" alt="" srcset=""> -->
  </div>

  <div class="section-footer">
    <div class="section-footer__med-variations">
      <app-button
        *ngFor="let product of variations"
        classList="btn bordered rounded"
        [text]="product.sameFamilyProductNavigation?.name || product.product.name"
        [link]="product.sameFamilyProductNavigation?.domain || product.product.domain"
      ></app-button>
    </div>
    <div class="section-footer__slider">
      <ul *ngIf="keyMessages.length > 2">
        <li *ngFor="let key of keyMessages; let i = index" (click)="changeKeyMessage(i)" >\</li>
      </ul>
    </div>
    <div></div>
  </div>
</section>
